export default __webpack_public_path__ + "static/media/tm.dfbaa21e.svg";